import { memo, useState } from "react";
import PropTypes from "prop-types";
import QuotationRoomDetailsModal from "./QuotationRoomDetailsModal";
import QuotationRoomBodyItem from "./QuotationRoomBodyItem";
import uniqBy from "lodash/uniqBy";
import QuotationBoards from "app/pages/Booking/Quotation/Board/QuotationBoards";

const QuotationRoomBody = ({
	rooms,
	boards = [],
	accommodationUpgradePrice = 0,
	isAccommodationIncluded,
	onBoardChange,
}) => {
	const [isRoomDetailsModalOpen, setIsRoomDetailsModalOpen] = useState(false);

	const uniqueRooms = uniqBy(rooms, "id");

	if (!uniqueRooms || uniqueRooms.length === 0) {
		return null;
	}

	const toggleOpenModal = () => {
		setIsRoomDetailsModalOpen(prev => !prev);
	};

	return (
		<div className="quotation-room-body">
			{uniqueRooms.map((room, index) => (
				<QuotationRoomBodyItem
					key={room.id + index}
					room={room}
					toggleOpenModal={toggleOpenModal}
				/>
			))}

			<QuotationRoomDetailsModal
				isOpen={isRoomDetailsModalOpen}
				onClose={toggleOpenModal}
				rooms={rooms}
			/>

			<QuotationBoards
				accommodationUpgradePrice={accommodationUpgradePrice}
				isAccommodationIncluded={isAccommodationIncluded}
				boards={boards}
				onChange={onBoardChange}
			/>
		</div>
	);
};

QuotationRoomBody.propTypes = {
	rooms: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			title: PropTypes.string,
			photos: PropTypes.arrayOf(
				PropTypes.shape({
					url: PropTypes.string,
					thumbnail: PropTypes.string,
				})
			),
			description: PropTypes.string,
			amenities: PropTypes.arrayOf(PropTypes.string),
			occupancy: PropTypes.shape({
				adults: PropTypes.number,
				children: PropTypes.number,
				babies: PropTypes.number,
			}),
		})
	),
	boards: PropTypes.array,
	accommodationUpgradePrice: PropTypes.number,
	isAccommodationIncluded: PropTypes.bool,
	onBoardChange: PropTypes.func,
};

export default memo(QuotationRoomBody);
